export const INITIAL_ALERTS_RECEIVED = "INITIAL_ALERTS_RECEIVED";
export const ALERT_BATCH_RECEIVED = "ALERT_BATCH_RECEIVED";
export const ALERT_RECEIVED = "ALERT_RECEIVED";
export const ALERT_REMOVED = "ALERT_REMOVED";
export const CLOSE_ALERT = "CLOSE_ALERT";
export const CLOSE_ALERTS = "CLOSE_ALERTS";
export const REOPEN_ALERT = "REOPEN_ALERT";
export const REOPEN_ALERTS = "REOPEN_ALERTS";
export const RESTORE_ALERTS = "RESTORE_ALERTS";

export const GET_ALERT_ARCHIVE_SUCCESS = "GET_ALERT_ARCHIVE_SUCCESS";
export const GET_ALERT_ARCHIVE_FAILED = "GET_ALERT_ARCHIVE_FAILED";
export const DUMP_ALERT_ARCHIVE = "DUMP_ALERT_ARCHIVE";
